import { Modal } from 'react-bootstrap';
import React from 'react';

import Editor from '../../editor/editor.jsx';

const StakeholderEditorFieldModal = ({ show, onHide, resource }) => {
  return (
    <Modal onHide={onHide} show={show}>
      <Modal.Header closeButton>
        <Modal.Title>
          <span className="text-capitalize">
            {resource ? resource.title : ''}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {resource ? (
          <Editor
            options={{
              holder: 'stakeholder-custom-field-editor',
              readOnly: true,
              minHeight: 0,
            }}
            data={resource.editorData}
          />
        ) : null}
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

export default StakeholderEditorFieldModal;
